// extracted by mini-css-extract-plugin
export default {"my_btn":"CustomBtnTransparentPersonalAccount_my_btn__CwHCp","logout_arrow":"CustomBtnTransparentPersonalAccount_logout_arrow__yQhHy"};